// Interface

import { ApiUserRole } from '@/enum/ApiUserRole'
import util from '@/utils/classToObject'
import { AdministrationGetter } from '../administration/getters'
import { IAuthState } from './state'

export class AuthGetter {
  public isAuthenticated(state: IAuthState) {
    return (state?.user?.id??0) > 0
  }
  public authStatus(state: IAuthState) {
    return state.authStatus
  }
  public token(state: IAuthState) {
    return state.token
  }
  public user(state: IAuthState) {
    return state.user
  }
  public userSecurity(state: IAuthState) {
    return state.userSecurity
  }
  public renewTokenId(state: IAuthState) {
    return state.renewTokenId
  }
  public redirectPath(state: IAuthState) {
    return state.redirectPath
  }
  public isAdminPlateforme(state: IAuthState) {
    return state.user.roles.findIndex(r => r == ApiUserRole.AdminPlateforme) > -1
  }  
  public isAdminPiscine(state: IAuthState){
    return state.user.roles.findIndex(r => r == ApiUserRole.AdminPiscine) > -1
  }
  public isClient(state: IAuthState) {
    return state.user.roles.findIndex(r => r == ApiUserRole.Client) > -1
  } 
  public isFamille(state: IAuthState) {
    return state.user.roles.findIndex(r => r == ApiUserRole.Famille) > -1
  } 
  public isMNS(state: IAuthState) {
    return state.user.roles.findIndex(r => r == ApiUserRole.MNS) > -1
  } 
  public isProprietairePisicne(state: IAuthState) {
    return state.user.roles.findIndex(r => r == ApiUserRole.ProprietairePiscine) > -1
  } 
  public canAccess(state: IAuthState) {        
    return (roles:Array<string>) => {      
      return state.user.roles.findIndex(r => r == ApiUserRole.AdminPlateforme) > -1              
          || roles.some(role =>                           
              ( role == "AdminPiscine" && state.user.roles.findIndex(r => r == ApiUserRole.AdminPiscine) > -1) 
           || (role == "Client" && state.user.roles.findIndex(r => r == ApiUserRole.Client) > -1) 
           || (role == "Famille" && state.user.roles.findIndex(r => r == ApiUserRole.Famille) > -1) 
           || (role == "MNS" && state.user.roles.findIndex(r => r == ApiUserRole.MNS) > -1) 
           || (role == "ProprietairePisicne" && state.user.roles.findIndex(r => r == ApiUserRole.ProprietairePiscine) > -1) 
      )
    } 
  }


}

export default util.classToObject(AuthGetter)
